var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { P, Pivot, R, Segments } from "apparatus/library/common";
import { Group, Path } from "paper";
import { staticImplements } from "types";
const SHELL_SPREAD_DEG = 50;
const WAVY_EFFECT_FACTOR = 0.3;
let Shell = class Shell {
    render({ size, ribs, color }) {
        const segments = [];
        // Render right half then mirror
        const lines = new Group([]);
        for (let i = 0; i <= ribs / 2; i++) {
            const angle = SHELL_SPREAD_DEG / (ribs / 2) * i;
            var point = P(0, -(size / 2) * (1 + WAVY_EFFECT_FACTOR * Math.cos(angle / SHELL_SPREAD_DEG * (90).toRadians()))); // Vary y to make it wavy
            point = point.rotate(angle, P(0, 0));
            // Handles need to be turned out more with the wavy effect.
            const handleAngle = angle + WAVY_EFFECT_FACTOR * 50 * Math.sin(angle / SHELL_SPREAD_DEG * (90).toRadians());
            const handleScale = size / 100 * 6 / ribs; // Bigger shell => bigger handles; more ribs => smaller handles
            const handleIn = P(-5, -5).multiply(handleScale).rotate(handleAngle);
            const handleOut = i !== ribs / 2 ? P(5, -5).multiply(handleScale).rotate(handleAngle) : P(0, 8).multiply(handleScale); // Last point smoothed out.
            segments.push([point, handleIn, handleOut]);
            // Draw a line, unless it's the last point
            if (i !== ribs / 2) {
                const line = (new Path.Line(P(0, -5).rotate(angle), point));
                lines.addChild(line);
                // Add mirrored line unless it's the center line
                if (i !== 0) {
                    const clonedLine = line.clone();
                    clonedLine.scale(-1, 1, P(0, 0));
                    lines.addChild(clonedLine);
                }
            }
        }
        segments.push([[5, -5], , [-2, 2]]);
        const body = new Path(Segments(...segments))
            .withDefaultStyle()
            .withFill(color)
            .mirrorX()
            .close();
        lines.withStroke("thin");
        const auricle = (new Path.Rectangle(R(0, -size / 16, size / 2, size / 5, Pivot.BOTTOM_CENTER), 3)
            .withDefaultStyle()
            .withFill(color));
        const graphic = new Group([auricle, body, lines]);
        return {
            graphic,
            hitShape: graphic.rectHitShape(),
            watermark: P(30, -5)
        };
    }
};
Shell.properties = {
    label: "Scallop Shell",
    defaultAppearance: {
        size: 100,
        ribs: 6,
        color: "#ffffff",
    },
    appearanceSpecs: [
        {
            spec: "slider", key: "size", label: "Size",
            min: 45, max: 180
        },
        {
            spec: "slider", key: "ribs", label: "Ribs",
            min: 6, max: 10, step: 2,
        },
        {
            spec: "color-wells", key: "color", label: "Colour",
            colors: [
                { label: "White", value: "#ffffff" },
                { label: "Beige", value: "#f5e7d4" },
            ]
        }
    ],
};
Shell = __decorate([
    staticImplements()
], Shell);
export { Shell };
